import {
  Container,
  Flex,
  Stack,
  Switch,
  Text,
  TextInput,
  rem,
} from "@mantine/core";
import { TranslateButton } from "ui";
import { UseFormReturnType } from "@mantine/form";
import { EventFormValues } from "./types";
import { IconCheck, IconX } from "@tabler/icons-react";

interface EventFormPriceProps {
  form: UseFormReturnType<EventFormValues>;
  isPtFirst: boolean;
  t: (key: string) => string;
  isFreeEvent: boolean;
  handleSetIsFreeEvent: (value: boolean) => void;
  handlePaste: (
    e: React.ClipboardEvent<HTMLTextAreaElement | HTMLInputElement>,
    field: keyof EventFormValues
  ) => void;
}

export const EventFormPrice = ({
  form,
  isPtFirst,
  t,
  isFreeEvent,
  handleSetIsFreeEvent,
  handlePaste,
}: EventFormPriceProps) => {
  return (
    <Container mt="lg" style={{ position: "relative", padding: 0 }}>
      <Text
        style={{
          position: "absolute",
          top: -10,
          left: 10,
          backgroundColor: "white",
          padding: "0 5px",
          color: "#6c757d",
        }}
        size="sm"
      >
        {t("events.price")}
      </Text>
      <Container
        style={{
          border: "1px #CED4DA solid",
          display: "flex",
          alignItems: "center",
        }}
        p="lg"
      >
        <Stack display="block" align="center" w="100">
          <Text size="sm">{t("events.free_event")}</Text>
          <Switch
            ml="sm"
            mt="xs"
            checked={isFreeEvent}
            onChange={() => handleSetIsFreeEvent(!isFreeEvent)}
            styles={{ label: { fontSize: 14, fontWeight: 500 } }}
            thumbIcon={
              isFreeEvent ? (
                <IconCheck
                  style={{ width: rem(12), height: rem(12) }}
                  stroke={3}
                />
              ) : (
                <IconX style={{ width: rem(12), height: rem(12) }} stroke={3} />
              )
            }
          />
        </Stack>
        {!isFreeEvent && (
          <Stack ml="md" w="100%">
            <Flex align="center">
              <Text size="sm">
                {isPtFirst ? t("common.pt") : t("common.en")}:
              </Text>
              <TextInput
                ml="sm"
                {...form.getInputProps(isPtFirst ? "price_pt" : "price")}
                w="100%"
                rightSection={
                  <TranslateButton
                    originalText={
                      isPtFirst ? form.values.price : form.values.price_pt
                    }
                    tragetLang={isPtFirst ? "pt" : "en"}
                    onTranslated={(translatedText) => {
                      form.setFieldValue(
                        isPtFirst ? "price_pt" : "price",
                        translatedText
                      );
                    }}
                  />
                }
                onPaste={(e) => {
                  handlePaste(e, isPtFirst ? "price_pt" : "price");
                }}
              />
            </Flex>
            <Flex align="center">
              <Text size="sm">
                {isPtFirst ? t("common.en") : t("common.pt")}:
              </Text>
              <TextInput
                ml="sm"
                mt="sm"
                {...form.getInputProps(isPtFirst ? "price" : "price_pt")}
                w="100%"
                rightSection={
                  <TranslateButton
                    originalText={
                      isPtFirst ? form.values.price_pt : form.values.price
                    }
                    tragetLang={isPtFirst ? "en" : "pt"}
                    onTranslated={(translatedText) => {
                      form.setFieldValue(
                        isPtFirst ? "price" : "price_pt",
                        translatedText
                      );
                    }}
                  />
                }
                onPaste={(e) => {
                  handlePaste(e, isPtFirst ? "price" : "price_pt");
                }}
              />
            </Flex>
          </Stack>
        )}
      </Container>
    </Container>
  );
};
